<template>
  <el-drawer :wrapperClosable="false" :visible.sync="ruleDialogVisble" size="480px" :show-close="false" destroy-on-close>
    <template #title>
      <div style="height: 50px">
        <drawer-header :title="ruleDialogTitle" :is-add="true" :subLoading="submitLoading" @close="handleClose"
                       @confirm="handleSubmit"/>
      </div>
    </template>
    <div style="padding:0 20px;">
      <el-form :model="holidayForm" :rules="holidayRule" ref="holidayRef">
        <el-row>
          <el-col>
            <el-form-item label="规则名称" prop="name">
              <el-input v-model="holidayForm.name"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="规则编号" prop="ruleNumber">
              <el-input-number :min="1" :precision="0" v-model="holidayForm.ruleNumber"
                               :disabled="holidayForm.id"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="是否启用">
              <el-switch v-model="holidayForm.status" :active-value="1" :inactive-value="0"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="是否允许通行">
              <el-switch v-model="holidayForm.permitted" :active-value="1" :inactive-value="0"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注">
              <el-input type="textarea" rows="2" v-model="holidayForm.remark"/>
            </el-form-item>
          </el-col>
          <!-- <el-col>
            <el-button type="primary" @click="handleAddHoliday">添加规则</el-button>
          </el-col> -->
        </el-row>
        <el-row :gutter="24" style="margin-top: 10px;">
          <el-col :span="24" v-for="(item, index) in holidayForm.rules" :key="'holiday_rule_'+index"
                  style="margin-bottom: 10px;">
            <el-card shadow="never">
              <template #header>
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <el-date-picker v-model="item.rulesDate"
                                  :key="'rule_time_key_'+index"
                                  style="width:calc(100% - 150px)"
                                  type="daterange"
                                  value-format="yyyy-MM-dd"
                                  range-separator="~"
                                  size="small"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                  <div>
                    全天
                    <el-switch v-model="item.rule.isFullDay" @change="(val) =>hanldeFullDay(val,item)"/>
                  </div>
                </div>
                <!-- <el-link type="danger" @click="handleDeleteRule(index)"
                  style="margin-left: 20px;">删除</el-link> -->
              </template>
              <div style="overflow-y: auto; height: 130px;">
                <el-form-item label="规则时段" style="margin-bottom: 0px ; white-space: nowrap;"
                              v-for="(rule, ruleIndex) in item.rule.intervals" :key="'rule_form_item_'+ruleIndex">
                  <el-time-picker style="width:calc(100% - 105px)"
                                  is-range
                                  size="small"
                                  @change.stop
                                  @blur.stop
                                  @focus.stop
                                  :key="'time-picker_'+index+'_'+ruleIndex"
                                  :disabled="item.rule.isFullDay"
                                  v-model="item.rule.intervals[ruleIndex]"
                                  format="HH:mm"
                                  value-format="HH:mm"
                                  start-placeholder="开始时间"
                                  range-separator="~"
                                  end-placeholder="结束时间"/>
                  <el-link type="primary" style="margin-left: 5px; margin-bottom: 5px;"
                           v-if="item.rule.intervals.length !== 6 && ruleIndex == 0 && !item.rule.isFullDay"
                           @click="handleAddTime(item.rule.intervals)">添加
                  </el-link>
                  <el-link type="danger" style="margin-left: 5px;margin-bottom: 5px;"
                           v-if="item.rule.intervals.length !== 1 && ruleIndex !== 0"
                           @click="handledelTime(item.rule.intervals,ruleIndex)">删除
                  </el-link>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import DrawerHeader from "@/components/drawerHeader.vue"
import {
  validRuleTime,
  hasDateRangeOverlap
} from "@/views/nexus/validRule"
import {
  HolidayRuleApi
} from "@/api/nexus/holiday"

export default {
  components: {
    DrawerHeader
  },
  props: {
    id: ''
  },
  data() {
    return {
      //dialog参数
      ruleDialogTitle: '',
      ruleDialogVisble: false,
      submitLoading: false,
      holidayForm: {},
      holidayRule: {
        name: {
          required: true,
          message: '请输入规则名称',
          trigger: 'blur'
        },
        ruleNumber: {
          required: true,
          message: '请输入规则编号',
          trigger: 'blur'
        }
      },
    }
  },
  methods: {
    //提交
    async handleSubmit() {
      this.submitLoading = true;
      this.$refs.holidayRef.validate(async valid => {
        if (valid && this.validateRules()) {
          //console.log("提交数据", this.holidayForm)
          let {
            code,
            message
          } = await HolidayRuleApi.getHolidaySave(this.holidayForm)
          if (code == 200) {
            this.$message.success("添加成功");
            this.ruleDialogVisble = false;
            this.$emit("on-load")
          } else {
            this.$message.error(message)
          }
        }
        this.submitLoading = false;
      })
    },
    //验证规则日期
    validateRules() {
      for (const [index, holiday] of this.holidayForm.rules.entries()) {
        if (holiday.rulesDate.length == 0) {
          this.$message.error("规则日期不能为空");
          return false;
        }
        if (hasDateRangeOverlap(this.holidayForm.rules, holiday.rulesDate, index)) {
          this.$message.error(`第 ${index + 1} 条规则日期与其他规则重叠`);
          return false;
        }
        //验证每个日期的时段
        // if (!validRuleTime(holiday.rule.intervals)) {
        //   this.$message.error(holiday.rulesDate[0].concat("~", holiday.rulesDate[1],
        //       "的规则时段配置错误，开始时间必须大于上一段的结束时间"))
        //   return false;
        // }
        this.$set(holiday, "startDate", holiday.rulesDate[0]);
        this.$set(holiday, "endDate", holiday.rulesDate[1]);
      }
      return true;
    },

    //验证当前操作的区间时段
    // changeTime(val, obj, index) {
    //   let bool = validRuleTime(obj.rule.intervals);
    //   if (!bool && obj.rulesDate.length > 0) {
    //     this.$message.error(obj.rulesDate[0].concat("~", obj.rulesDate[1], "的规则时段配置错误，开始时间必须大于上一段的结束时间"))
    //   }
    // },
    //移除当前规则
    handleDeleteRule(index) {
      this.holidayForm.rules.splice(index, 1)
    },
    //添加规则
    handleAddHoliday() {
      let rules = {
        rulesDate: [],
        rule: {
          isFullDay: false,
          intervals: [
            ["00:00", "23:59"]
          ]
        }
      }
      this.holidayForm.rules.push(rules);
    },
    //开启全天
    hanldeFullDay(val, obj) {
      if (val) {
        obj.rule.intervals.splice(0);
        obj.rule.intervals.push(["00:00", "23:59"]);
      }
    },
    //添加时段
    handleAddTime(times) {
      times.push(["00:00", "23:59"])
    },
    //移除时段
    handledelTime(times, index) {
      times.splice(index, 1)
    },

    //关闭抽屉
    handleClose() {
      this.ruleDialogVisble = false;
    },
    //打开对话框
    async show(title) {
      this.ruleDialogTitle = title
      if (!this.id) {
        let {
          code,
          data
        } = await HolidayRuleApi.getRuleNumber();
        if (code == 200) {
          this.initHolidayForm(data);
        }
      } else {
        let {
          code,
          data
        } = await HolidayRuleApi.getById(this.id)
        if (code == 200) {
          data.rules.forEach(item => {
            this.$set(item, "rulesDate", [item.startDate, item.endDate])
          })
          this.holidayForm = Object.assign({}, data)
        }
      }
      this.ruleDialogVisble = true
    },
    //初始化表单
    initHolidayForm(number) {
      let form = {
        name: '',
        ruleNumber: number,
        status: 1,
        permitted: 1,
        remark: '',
        rules: [{
          rulesDate: [],
          rule: {
            isFullDay: false,
            intervals: [
              ["00:00", "23:59"]
            ]
          }
        }]
      };
      this.holidayForm = Object.assign({}, form);
    }
  }
}
</script>

<style>
</style>